import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";
import DateFilters from "../../views/DateFilters";
import { actionCreators } from "../../redux/sagas/referrals";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import KBLearnMore from "../../../../components/learnMore/KBLearnMore";
import NoData from "../../../../components/noData/noData";
import { ILEARN_URLS } from "../../../../constants/ilearnUrls";

const TotalRevenue = (props) => {
  const dispatch = useDispatch();
  const { moduleName, chartContentTitle } = props;
  const { toggleView, updateFilters, updateReferralToggle, updateData, fetchData, resetData } =
    actionCreators(moduleName);

  const {
    dataTable: { rows = [], cols = [] },
    options,
    initialRequest,
    isTable,
    filters,
    isAllSitesMode,
    isLoading
  } = useSelector((state) => state[moduleName]);
  // switch between table and chart views
  const switchView = (view) => dispatch(toggleView({ moduleName, view, filters }));
  const showNoDataMessage = rows?.every((elem) => elem[1]?.v === 0);

  useEffect(() => {
    !initialRequest && dispatch(fetchData(props));
  }, []);

  let content = () => (
    <div id="module-date-filters" className="total-revenue-by-referral" data-testid={moduleName}>
      {isAllSitesMode ? (
        <p className="error error--big">
          Not Available in All Sites View, when user has access to more than 100 locations
        </p>
      ) : (
        <>
          <DateFilters
            moduleName={moduleName}
            actionCreators={{
              updateFilters,
              updateReferralToggle,
              updateData,
              fetchData: resetData
            }}
          />
          <div className="chart-root">
            {showNoDataMessage ? (
              <NoData />
            ) : (
              <GoogleChart
                chartName="total_revenue_by_referral_source_chart"
                isTableView={isTable}
                enableEventListeners
                height={540}
                chartType={isTable ? "Table" : "PieChart"}
                rows={rows}
                columns={cols}
                switchView={switchView}
                options={options}
                showAdditionTooltip={false}
              />
            )}
          </div>
        </>
      )}
    </div>
  );

  return (
    <SectionToggle
      isLoading={isLoading}
      height={400}
      title={chartContentTitle}
      content={content()}
      learnMore={
        <KBLearnMore
          title={chartContentTitle}
          description="This report shows total revenue generated by clients who entered through specific referral sources. These insights help you assess ROI by channel, identify high-value referral paths, and refine marketing strategies for stronger long-term growth."
          kbUrl={ILEARN_URLS.marketing.totalRevenue}
        />
      }
    />
  );
};

export default React.memo(TotalRevenue);
